// @flow

import { BASE_URL } from 'app/settings/utils/constants';

const routes = {
  [BASE_URL]: {
    fetch: () =>
      import(
        /* webpackChunkName: 'settings-route' */ 'app/settings/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
